/*
 *   timeToLive - The maximum number of seconds an element can exist in the storage regardless of use. The element
 *                expires at this limit and will no longer be returned from the storage. Use 'FOREVER' for no eviction.
 *
 *   storageType - 'SESSION' for session web storage
 *                 'LOCAL' for local web storage
 *
 *   propKeys - If set, will only load from storage if the props match the props that the component had when the
 *              storage was saved.
 *
 *   version - When the persisted model signature changes, the version number must be incremented to the user
 *             won't use bad data.
 */
var commonPersistenceConfigs = require('swa-app-configuration/common-persistence-configs');

module.exports = commonPersistenceConfigs({
    CorporateLandingHomePageIndex: {
        resetCheckInterval: 60,
        resetStoreOnExpiration: true,
        stateToPersist: [
            'activeChangeCancelTab',
            'corporateLandingHomePageAirSearchSearchFormData',
            'corporateLandingHomePageCancelSearchFormData',
            'corporateLandingHomePageCarBookingSearchFormData',
            'corporateLandingHomePageChangeCancelSearchFormData',
            'corporateLandingHomePageChangeSearchFormData',
            'corporateLandingHomePageCheckInAirReservationSearchFormData',
            'corporateLandingHomePageFlightStatusSearchFormData',
            'loggedIn',
            'selectedTab'
        ],
        storageType: 'SESSION',
        timeToLive: 1800,
        version: 1
    },
    LandingAirRecentSearchStore: require('swa-air-core/persistence-config-air-recent-search-store'),
    ResetStatusSearchStore: require('swa-search/persistence-config-reset-status-search-store')
});
